<template>
    <div class="relative overflow-hidden text-right mb-3">
        <a
            href="#"
            @click.prevent="setShowAffiliateModal(true)"
            class="text-orange text-xs hover:text-orange-400"
        >
            Affiliate Disclosure
        </a>
    </div>

    <section
        class="bg-white mb-8 shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
    >
        <div class="relative isolate">
            <div
                class="mx-auto max-w-7xl px-6 py-8 lg:flex lg:items-center lg:gap-x-10 lg:px-8"
            >
                <div class="lg:mt-0 lg:flex-shrink-0 lg:flex-grow">
                    <img
                        src="/images/companionpass/companionpass.png"
                        class="-skew-y-3 shadow-inner -rotate-6 mx-auto w-32 lg:w-auto"
                    />
                </div>

                <div class="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
                    <div class="mb-5">
                        <h1
                            class="mt-10 text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl"
                        >
                            Companion Pass Mode Makes Earning the Southwest
                            Companion Pass Simple
                        </h1>
                        <p class="mt-6 text-lg leading-8 text-gray-600">
                            Enable My10x's Companion Pass Mode to be guided
                            through the process of earning the Companion Pass.
                        </p>
                        <p class="mt-6 text-lg leading-8 text-gray-600">
                            Receive automated notifications and reminders that
                            guide you step-by-step through the process of
                            earning the Companion Pass.
                        </p>
                    </div>
                    <div>
                        <CompanionPassToggle />
                    </div>
                    <div v-if="fiveTwentyFour" class="mt-5 mx-auto max-w-7xl">
                        <div class="mx-auto max-w-4xl">
                            <div class="rounded-md bg-red-50 p-4">
                                <div class="rounded-md bg-red-50 p-4">
                                    <div class="flex">
                                        <div
                                            class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                                        >
                                            <svg
                                                class="h-6 w-6 text-red-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5"
                                                stroke="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                                ></path>
                                            </svg>
                                        </div>
                                        <div class="ml-3">
                                            <h3
                                                class="text-base font-medium text-red-800"
                                            >
                                                You're Over 5/24
                                            </h3>
                                            <div
                                                class="mt-2 text-sm text-red-700"
                                            >
                                                <p>
                                                    You're over 5/24, which
                                                    means you can't earn the
                                                    Companion Pass using the
                                                    strategy we outline here
                                                    since you're unable to open
                                                    any Chase cards.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="ml-auto pl-3">
                                            <div class="-mx-1.5 -my-1.5">
                                                <button
                                                    type="button"
                                                    class="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
                                                    @click="
                                                        setFiveTwentyFour(false)
                                                    "
                                                    v-if="canDismiss524Alert"
                                                >
                                                    <span class="sr-only">
                                                        Dismiss
                                                    </span>
                                                    <svg
                                                        class="h-5 w-5"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div
        class="w-full rounded-md bg-red-50 border-l-4 border-red-400 p-4 mb-6 max-w-3xl mx-auto"
        v-if="beforeStartDate"
    >
        <div class="flex">
            <div class="flex-shrink-0">
                <span class="fa-stack relative z-20 fa-lg">
                    <i class="fa-solid fa-circle fa-stack-2x text-red-100"></i>
                    <i
                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                    ></i>
                </span>
            </div>
            <div class="ml-3">
                <h3 class="text-base font-medium text-red-800">
                    Sit tight for a few days.
                </h3>
                <div class="mt-2 text-sm text-red-700">
                    <ul role="list" class="list-disc space-y-1 pl-5">
                        <li>
                            We recommend
                            <strong>
                                waiting until 10/01/2024 before starting
                            </strong>
                            this process. Waiting gives you at least 16 days in
                            January to meet your minimum spend, which reduces
                            the risk of messing up the timing..
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div
        class="relative overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
    >
        <div class="grid grid-cols-2">
            <div id="tabs" class="col-span-2 xl:col-span-1 xl:pr-12">
                <div
                    v-for="(tab, tIndex) in steps"
                    :key="`tab-${tIndex}`"
                    class="hover:bg-gray-50 transition-all lg:px-10 group !cursor-pointer outline-none"
                    :class="{
                        'bg-gray-100 ': tIndex === stepIndex && !tab.too_early,
                        'bg-white': tIndex !== stepIndex || tab.too_early,
                    }"
                    @click="setStepIndex(tIndex)"
                    :id="`step-${tIndex}`"
                >
                    <div class="border-b py-8">
                        <div
                            class="grid grid-cols-[auto_1fr_auto] grid-flow-col auto-cols-fr gap-x-6 items-center mb-3 px-10 lg:px-0"
                        >
                            <div
                                class="font-sm text-orange"
                                :class="{
                                    'opacity-50':
                                        tab.complete && !tab.too_early,
                                }"
                            >
                                {{ tab.num }}
                            </div>
                            <h3
                                class="font-medium text-lg lg:text-xl group-hover:text-orange transition"
                                :class="{
                                    '!text-orange': tIndex === stepIndex,
                                    '!text-black': tIndex !== stepIndex,
                                    'opacity-50':
                                        tab.complete && !tab.too_early,
                                }"
                            >
                                {{ tab.title }}
                            </h3>
                            <div>
                                <span
                                    class="fa-stack"
                                    v-if="tab.complete && !tab.too_early"
                                >
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-green-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                                    ></i>
                                </span>
                                <div
                                    v-if="!tab.complete"
                                    class="group-hover:block"
                                    :class="{
                                        '': tIndex === stepIndex,
                                        hidden: tIndex !== stepIndex,
                                    }"
                                >
                                    <i
                                        class="fa-regular fa-arrow-right text-orange font-sm"
                                    ></i>
                                </div>
                            </div>
                        </div>
                        <transition name="expand-collapse">
                            <div v-if="tIndex === stepIndex" mode="out-in">
                                <div
                                    class="py-3 px-10 lg:px-0"
                                    :class="{
                                        'opacity-50':
                                            tab.complete && !tab.too_early,
                                    }"
                                >
                                    <p
                                        class="text-base lg:text-lg mb-3"
                                        v-html="tab.short_content"
                                    ></p>
                                </div>
                            </div>
                        </transition>
                        <transition name="grow">
                            <div
                                class="block xl:hidden bg-orange-100 outline-none"
                                v-if="stepIndex === tIndex"
                            >
                                <keep-alive>
                                    <component :is="`Step${tIndex}`" />
                                </keep-alive>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="hidden xl:block col-span-2 xl:col-span-1">
                <transition name="fade" mode="out-in">
                    <div
                        class="h-full bg-orange-100 outline-none"
                        :key="`step-panel-${stepIndex}`"
                    >
                        <component :is="`Step${stepIndex}`" />
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppStore } from '@/store/app';
import { useCompanionPassStore } from '@/store/companionpass';

import Step0 from '@/components/companion-pass/tab-panels/step-1.vue';
import Step1 from '@/components/companion-pass/tab-panels/step-2.vue';
import Step2 from '@/components/companion-pass/tab-panels/step-3.vue';
import Step3 from '@/components/companion-pass/tab-panels/step-4.vue';
import Step4 from '@/components/companion-pass/tab-panels/step-5.vue';
import Step5 from '@/components/companion-pass/tab-panels/step-6.vue';
import Step6 from '@/components/companion-pass/tab-panels/step-7.vue';
import Step7 from '@/components/companion-pass/tab-panels/step-8.vue';
import CompanionPassToggle from '@/components/companion-pass/companion-pass-toggle.vue';

export default {
    name: 'CompanionPass',
    props: {},
    components: {
        Step0,
        Step1,
        Step2,
        Step3,
        Step4,
        Step5,
        Step6,
        Step7,
        CompanionPassToggle,
    },
    data: () => ({
        altStepIndex: -1,
    }),
    computed: {
        ...mapState(useCompanionPassStore, [
            'steps',
            'passEnabled',
            'fiveTwentyFour',
            'fiveTwentyFourModal',
            'canDismiss524Alert',
            'completeSteps',
            'beforeStartDate',
        ]),
        userPassEnabled: {
            set(val) {
                this.setPassEnabled(val);
            },
            get() {
                return this.passEnabled;
            },
        },
        stepIndex() {
            if (this.altStepIndex > -1) {
                return this.altStepIndex;
            }
            let items = Object.keys(this.completeSteps).length;
            if (items === 8) {
                items = 7;
            }

            if (this.steps[0].too_early) {
                items = 0;
            }

            return items === 0 ? 0 : items;
        },
    },
    watch: {
        userPassEnabled() {
            this.togglePass();
        },
    },
    methods: {
        ...mapActions(useAppStore, ['setShowAffiliateModal']),
        ...mapActions(useCompanionPassStore, [
            'getPassData',
            'getSteps',
            'updateCompleteSteps',
            'setPassEnabled',
            'setFiveTwentyFour',
            'togglePass',
        ]),
        setStepIndex(index) {
            this.altStepIndex = index;
            this.steps.forEach((step, i) => {
                step.selected = false;
                if (i === index) {
                    step.selected = true;
                }
            });
            this.scrollToTab();
        },
        scrollToTab() {
            if (window.innerWidth <= 1280) {
                setTimeout(() => {
                    const id = 'step-' + this.stepIndex;
                    const target = document.getElementById(id);
                    target.scrollIntoView({
                        behavior: 'smooth',
                    });
                }, 600);
            }
        },
    },
    async mounted() {
        this.getSteps();
        await this.updateCompleteSteps();
        this.scrollToTab();
    },
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.grow-enter-active,
.grow-leave-active {
    transition: transform 0.5s ease;
    transform: scale(0);
}

.grow-enter-from {
    //transform: translateY(100%);
    transform: scale(0);
}
.grow-leave-to {
    //transform: translateY(0);
    transform: scale(1);
}

.expand-collapse-enter-active,
.expand-collapse-leave-active {
    transition: max-height 0.5s ease;
    max-height: 100px;
}

.expand-collapse-enter-from,
.expand-collapse-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}
</style>
